export function generateShade(baseHex, targetHex, newHex) {
  // Convert hex colors to RGB
  let r1 = parseInt(baseHex.slice(1, 3), 16);
  let g1 = parseInt(baseHex.slice(3, 5), 16);
  let b1 = parseInt(baseHex.slice(5, 7), 16);

  let r2 = parseInt(targetHex.slice(1, 3), 16);
  let g2 = parseInt(targetHex.slice(3, 5), 16);
  let b2 = parseInt(targetHex.slice(5, 7), 16);

  let rNew = parseInt(newHex.slice(1, 3), 16);
  let gNew = parseInt(newHex.slice(3, 5), 16);
  let bNew = parseInt(newHex.slice(5, 7), 16);

  // Calculate the RGB adjustment
  let deltaR = r2 - r1;
  let deltaG = g2 - g1;
  let deltaB = b2 - b1;

  // Apply the adjustment to the new hex color
  let newR = Math.min(255, Math.max(0, rNew + deltaR))
    .toString(16)
    .padStart(2, "0");
  let newG = Math.min(255, Math.max(0, gNew + deltaG))
    .toString(16)
    .padStart(2, "0");
  let newB = Math.min(255, Math.max(0, bNew + deltaB))
    .toString(16)
    .padStart(2, "0");

  // Return the resulting color in hex format
  return `#${newR}${newG}${newB}`;
}
